module.exports = __webpack_public_path__ + "static/img/DEV4-dPqPDurT.f7aabf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DEV4-dPqPDurT.png
// module id = yWJp
// module chunks = 16